import { Trans } from '@lingui/macro'
import { FC, Fragment } from 'react'

import { FeedObjectQuestionView, FeedUserView } from '../../../interfaces'
import { getRelativeTime } from '../../../utils/time'
import AnswerDetails from '../AnswerDetails'
import styles from './QuestionDetails.module.css'

interface Props {
  pageProfiles: { [userId: string]: FeedUserView }
  slug?: string
  view: FeedObjectQuestionView
}

const QuestionDetails: FC<Props> = props => {
  const updatedAt = parseInt(props.view.question.updatedAt, 10)
  const relativeTime = getRelativeTime(updatedAt)
  const questionText = props.view.question.questionText.value
  const answers = (props.view.question.answerList || [])
    .filter(answer => answer.answerText.value)
    .map((answer, index, xs) => (
      <Fragment key={answer.id}>
        <AnswerDetails answer={answer} profiles={props.pageProfiles} questionText={questionText} />
        {index !== xs.length - 1 ? <div className={styles.emptyBar} /> : null}
      </Fragment>
    ))

  const qProfile = props.pageProfiles[props.view.question.userId]

  return (
    <article className={styles.wrapper}>
      <div className={styles.questionWrapper}>
        {qProfile?.bio?.value ? <span className={styles.bio}>{qProfile.bio.value}</span> : null}
        <header className={styles.questionText}>
          <h3>{questionText}</h3>
        </header>
        <div className={styles.metadataRow}>
          {props.view.question.answerCount} <Trans>Answers</Trans>
          <span>
            🕑 <Trans>Updated {relativeTime}</Trans>
          </span>
        </div>
      </div>
      {answers}
    </article>
  )
}

export default QuestionDetails
